import { OWebTNet, tRouteStateObject, tViewDialog } from "oweb";
import { checkUpdate } from "@/utils/update";
import app from "@/app";

app.pager.onLocationChange((route, page) => {
	app.store.page = page;
	app.store.route = route;
	app.store.routeContext = app.router.getRouteContext();
});

app.view.onFreeze(() => {
	app.store.frozen = true;
	$(document.body).addClass("oweb-freeze");
}).onUnFreeze(() => {
	app.store.frozen = false;
	$(document.body).removeClass("oweb-freeze");
}).onDialog((dialog: tViewDialog, can_use_alert: boolean) => {

	let { text, data } = dialog;

	if (text && text.length) {
		if (can_use_alert && app.isMobileApp()) {
			alert(app.i18n.toHuman(text, data));
		} else {
			app.store.dialogs.push(dialog);
		}
	}
});

app.onReady(function () {
	let entryPoint = location.href,
		ctx = this,
		tNet = new OWebTNet(ctx),
		next = function (path?: string, state?: tRouteStateObject) {
			ctx.store.ready = true;
			ctx.store.splash = false;

			ctx.router.start(true, path, state);

			checkUpdate(ctx);
		};

	console.log("[App] entry point ->", entryPoint);

	tNet.on(OWebTNet.EVT_TNET_READY, (state: string) => {
		switch (state) {
			case OWebTNet.STATE_VERIFIED_USER:
				next();
				break;
			case OWebTNet.STATE_OFFLINE_USER:
				next();
				ctx.notifyOffline();
				break;
			case OWebTNet.STATE_SIGN_UP_PROCESS:
				next("/signup/one");
				break;
			case OWebTNet.STATE_NO_USER:
				next();
				break;
			case OWebTNet.STATE_UNKNOWN:
				next();
				ctx.notifyOffline();
				break;
		}
	}).check();
});

function cacheRoute(
	target: any,
	propertyKey: string,
	descriptor: PropertyDescriptor
) {
	console.log("[cacheRoute] descriptor arguments", arguments);
	const originalMethod = descriptor.value;
	descriptor.value = function () {
		console.log("[cacheRoute] fn replaaced!", originalMethod());
	};
	return descriptor;
}
